import script from "./message-input-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-input-button.vue?vue&type=script&setup=true&lang=ts"

import "./message-input-button.vue?vue&type=style&index=0&id=017ab692&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.31_vue@3.5.31_typescript@5.6.3__webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-017ab692"]])

export default __exports__